import React from 'react';

import { motion } from 'framer-motion';

import { Portal, PortalArea } from '@pkg/components';

import './RevealTransition.scss';

interface ArtifactsRevealTransitionProps {
    duration: number;
}

export function ArtifactsRevealTransition({ duration }: ArtifactsRevealTransitionProps) {
    return (
        <Portal destination={PortalArea.Transition}>
            <motion.div
                initial={{ clipPath: 'circle(1% at 0% 100%)', opacity: 0.25 }}
                animate={{ clipPath: 'circle(200% at 0% 100%)', opacity: 1 }}
                transition={{ duration: (duration - 50) / 1000, easing: 'circOut' }}
                className="yat-artifacts__reveal-transition"
            />
        </Portal>
    );
}
